module.exports = __webpack_public_path__ + "static/media/icon-update_save_exit-black.f8937975.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-update_save_exit-black.svg
// module id = ./src/assets/images/icon-update_save_exit-black.svg
// module chunks = 6